import { render, staticRenderFns } from "./EModalRelatorioBuscaAtiva.vue?vue&type=template&id=f2b434be"
import script from "./EModalRelatorioBuscaAtiva.vue?vue&type=script&lang=js"
export * from "./EModalRelatorioBuscaAtiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports